import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";

/**✅ get Contacts Thunk */
export const getContactThunk = createAsyncThunk(
    "contacts/getContactThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "getContact") {
            if (state.contacts?.getContacts?.length > 0) {
                return state.contacts.getContacts;
            }
        }

        try {
            const response = await api.post(API_ROUTES.CONTACTS, {
                client_id: user?.client_id
            });


            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch contacts");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ get Tags Thunk */
export const getTagsThunk = createAsyncThunk(
    "contacts/getTagsThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "tags") {
            if (state.contacts?.getTags?.length > 0) {
                return state.contacts.getTags;
            }
        }

        try {
            const response = await api.post(API_ROUTES.TAGS, {
                client_id: user?.client_id
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch Tags");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ add Tag Thunk **/
export const addTagThunk = createAsyncThunk(
    "contacts/addTagThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            client_id: user?.client_id
        };

        try {
            const response = await api.post(API_ROUTES.ADDTAG, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Tag Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Tag Adding failed"
            );
        }
    }
);

/**✅ add ContactThunk Thunk **/
export const addContactThunk = createAsyncThunk(
    "contacts/addContactThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id
        };

        try {
            const response = await api.post(API_ROUTES.ADDCONTACT, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Tag Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Tag Adding failed"
            );
        }
    }
);

/**✅ add ContactThunk Thunk **/
export const updateContactThunk = createAsyncThunk(
    "contacts/updateContactThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id
        };

        try {
            const response = await api.post(API_ROUTES.UPDATECONTACT, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 200) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Tag Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Tag Adding failed"
            );
        }
    }
);

/**✅ add Tag Thunk **/
export const updateTagThunk = createAsyncThunk(
    "contacts/updateTagThunk",
    async ({ credentials }, { rejectWithValue, }) => {

        try {
            const response = await api.post(API_ROUTES.UPDATE_TAG, credentials);
            const { message, statusCode } = response.data;

            if (statusCode === 200) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Tag Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Tag Adding failed"
            );
        }
    }
);

// create organization thunk
export const addOrganizationThunk = createAsyncThunk(
    "contacts/addOrganizationThunk",

    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            client_id: user?.client_id
        };

        try {
            const response = await api.post(API_ROUTES.ADDORGANIZATION, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Organization Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Organization Adding failed"
            );
        }
    }
);


// get organizations thunk

export const getOrganizationsThunk = createAsyncThunk(
    "contacts/getOrganizationsThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "getOrganizations") {
            if (state.contacts?.getOrganizations?.length > 0) {
                return state.contacts.getOrganizations;
            }
        }

        try {
            const response = await api.post(API_ROUTES.GETORGANIZATIONS, {
                client_id: user?.client_id
            });


            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch organizations");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);


export const getIndividualUserThunk = createAsyncThunk(
    "userProfile/getUserProfileThunk",
    async (payload = {}, { rejectWithValue }) => {

        try {
            const response = await api.post(API_ROUTES.GETUSERPROFILE, payload);

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch organizations");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);
